var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-list"},[(_vm.alertList.length > 0)?_c('div',_vm._l((_vm.alertList),function(alert,index){return _c('div',{key:index},[_c('AlertItem',{attrs:{"id":index,"alert":alert},on:{"close":function($event){return _vm.closeAlert(alert.idt_aff_notification,index)}}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }